export interface UpdateFacilityRoleDto {
  name: string; // Required, max 100 characters
  description?: string | null; // Optional, max 500 characters
  isActive: boolean; // Required
  permissionTypeIds?: number[]; // Default empty array
}
